import React from "react";
import {
    SettingsIcon,
    StyledLabel,
    StyledSelectInput,
} from "@aureskonnect/react-ui";
import { useTranslation } from "react-i18next";
import { AvForm, AvField, AvGroup } from "availity-reactstrap-validation";
import classnames from "classnames";
import { components } from "react-select";
import { useSnapshot } from "valtio";
import ReactSwitch from "react-switch";

import {
    ipMatchWord,
    numberMatchWord,
    AdyenCurrencies,
} from "@constants/index";
import { SupportCodeModal } from "./SupportCodeModal";
import { ArrowDownIcon } from "@components/Common/SvgIcons/ArrowDownIcon";
import { AdyenConfigurationModal } from "./AdyenConfigurationModal";
import { store as userStore } from "../../../../components/VerticalLayout/store";
import ConfirmationModal from "./ConfirmationModal";

import "react-toastify/dist/ReactToastify.css";
import "../index.css";
import { useFetchGlobal } from "../../../../api/hooks";
import { useMoneticsForm } from "./MoneticsFormContext";
import {
    COMMUNICATION_LOCAL,
    MONETIC_MODE_TEST,
    MONETIC_MODE_PRODUCTION,
    ADYEN_PORT_BASE,
    ADYEN_WEBHOOK_BASE,
    ADYEN_AUTOFILL_DISABLE_DELAY_MS,
} from "./moneticsConstants";
import { FieldError } from "./components/FieldError";

export function AdyenConfiguration() {
    const { form, props } = useMoneticsForm();
    const {
        port,
        setPort,
        webhook,
        setWebhook,
        inputWebhook: inputWebHook,
        ipAddress,
        setIpAddress,
        mode,
        setMode,
        inputMode,
        setInputWebhook,
        setInputMode,
        setInputPortAdyen,
        inputPortAdyen,
        IDAdyen,
        setSelectedIdAdyen,
        selectedIdAdyen,
        isShopHasAdyen,
        merchantAccountId,
        currency: currencyByShop,
        setAdyenConfig,
        adyenConfig,
        isAutoFill,
        setIsAutoFill,
        isIdExist,
        setIsIdExist,
        isDisabled,
        setIsDisabled,
        setInputID,
        inputID,
    } = form;
    const { ipExist, setInputIp, setIsEdited, isConsult } = props;
    const inputIp = props.InputIp;
    // shopIds/editedData stay loosely typed (as in the original prop contract)
    // because this component's untouched body indexes into them freely.
    const shopIds: any = props.shopIds;
    const editedData: any = props.editedData;
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();
    const [isModalOpened, setIsModalOpened] = React.useState<boolean>(false);
    const [
        isConfirmationModalOpened,
        setIsConfirmationModalOpened,
    ] = React.useState<boolean>(false);
    const [
        isConfigurationModalOpened,
        setIsConfigurationModalOpened,
    ] = React.useState<boolean>(false);
    const [isConfig, setIsConfig] = React.useState<boolean>(false);
    const [codeSupport, setCodeSupport] = React.useState<string>("");
    const [isValidCode, setIsValidCode] = React.useState(false);
    const { oneShop, userID, franchiseID, shopID } = useSnapshot(userStore);
    const shopId = oneShop ? shopID : shopIds[0] ?? editedData.shopId;
    const [, setMerchantAccount] = React.useState<string>(
        adyenConfig.merchantAccount === undefined
            ? merchantAccountId !== undefined
                ? merchantAccountId
                : ""
            : adyenConfig.merchantAccount
    );
    /* eslint-disable */
    const [shopIdentifier, setShopIdentifier] = React.useState<string>(
        adyenConfig.shopIdentifier === undefined
            ? ""
            : adyenConfig.shopIdentifier
    );
    const [cryptoVersion, setCryptoVersion] = React.useState<string>(
        adyenConfig.cryptoVersion === undefined ? "" : adyenConfig.cryptoVersion
    );
    const [keyIdentifier, setKeyIdentifier] = React.useState<string>(
        adyenConfig.keyIdentifier === undefined ? "" : adyenConfig.keyIdentifier
    );
    const [passphrase, setPassphrase] = React.useState<string>(
        adyenConfig.passphrase === undefined ? "" : adyenConfig.passphrase
    );
    const [keyVersion, setKeyVersion] = React.useState<string>(
        adyenConfig.keyVersion === undefined ? "" : adyenConfig.keyVersion
    );
    const [communication, setCommunication] = React.useState<string>(
        adyenConfig.communication === undefined
            ? COMMUNICATION_LOCAL
            : adyenConfig.communication
    );
    const [webhookConfig, setWebhookConfig] = React.useState<string>(
        adyenConfig.webhook === undefined ? "" : adyenConfig.webhook
    );
    const [merchantTicket, setMerchantTicket] = React.useState<boolean>(
        adyenConfig.merchantTicket === undefined
            ? false
            : adyenConfig.merchantTicket
    );
    const [customerTicket, setCustomerTicket] = React.useState<boolean>(
        adyenConfig.customerTicket === undefined
            ? true
            : adyenConfig.customerTicket
    );
    const [apiKey, setApiKey] = React.useState<string>(
        adyenConfig.apiKey === undefined ? "" : adyenConfig.apiKey
    );
    const [userName, setUserName] = React.useState<string>(
        adyenConfig.userName === undefined ? "" : adyenConfig.userName
    );
    const [userPassword, setUserPassword] = React.useState<string>(
        adyenConfig.userPassword === undefined ? "" : adyenConfig.userPassword
    );
    const [devise, setDevise] = React.useState<string[]>(
        adyenConfig.currency === undefined ? [] : adyenConfig.currency
    );
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";

    const dataFetch = async () => {
        const data: any = await fetchGlobal<any>(
            `${process.env.REACT_APP_API_V2_URL}/settings/general/devise?userId=${userID}&shopId=${shopId}&franchiseId=${franchiseID}&type=activated`,
            {
                method: "GET",
                headers: { "Accept-Language": i18nextLng },
            }
        );
        let devise: any[] = [];
        if (data.data !== undefined) {
            data.data.forEach((element: any) => {
                let deviseExist = AdyenCurrencies.find(
                    (el: any) => el.code === element[t("Currency")]
                );
                if (deviseExist !== undefined && element.isActive === true) {
                    devise.push({
                        label: element[t("Currency")],
                        value: element[t("Currency")],
                    });
                }
            });
        }
        setDevise(devise[0] ?? []);
    };
    const options = IDAdyen.map((item: any) => ({
        label: item,
        value: item,
    }));

    const getFetch = async (option: any) => {
        if (option !== undefined) {
            setIsDisabled(true);
            const api = `${process.env.REACT_APP_ACCESS_API_URL}/storeTerminalDetails?merchantaccount=${merchantAccountId}&terminalId=${option}`;
            const data = await fetchGlobal<any>(api, {
                headers: {
                    "Content-Type": "application/json",
                },
                method: "GET",
            });
            setAdyenConfig({
                ...adyenConfig,
                cryptoVersion: data.adyenCryptoversion,
                keyIdentifier: data.Identifier,
                passphrase: data.Passphrase,
                keyVersion: data.Keyversion,
                communication,
                webhook: data.webhookServerUrl,
                merchantTicket,
                customerTicket,
                apiKey: data.cleApi,
                userName: data.useName,
                userPassword: data.pwd,
                isAutoFill: data.isAutoFill,
            });
            if (data.adressIp !== undefined) {
                setIpAddress(data.adressIp !== undefined ? data.adressIp : "");
                setPort(addToBase(data.adressIp, ADYEN_PORT_BASE).toString());
                setWebhook(
                    addToBase(data.adressIp, ADYEN_WEBHOOK_BASE).toString()
                );
                setTimeout(() => {
                    setIsDisabled(false);
                }, ADYEN_AUTOFILL_DISABLE_DELAY_MS);
            } else {
                setIpAddress("");
                setPort("");
                setWebhook("");
                setTimeout(() => {
                    setIsDisabled(false);
                }, ADYEN_AUTOFILL_DISABLE_DELAY_MS);
            }
        }
    };
    React.useEffect(() => {
        if (isAutoFill && isShopHasAdyen) {
            if (options.length === 0) {
                setIpAddress("");
                setWebhook("");
                setPort("");
                setSelectedIdAdyen({
                    value: "",
                    label: "",
                });
                setInputIp(false);
            }
        }

        // eslint-disable-next-line
    }, [isAutoFill]);

    React.useEffect(() => {
        shopIds.length <= 1 || editedData.Id !== undefined
            ? dataFetch()
            : setDevise([]);
        // eslint-disable-next-line
    }, [shopIds.length, editedData.Id]);

    React.useEffect(() => {
        if (isAutoFill && isShopHasAdyen) {
            getFetch(selectedIdAdyen.value);
        }
    }, [selectedIdAdyen, merchantAccountId]);

    const DropdownIndicator = (props: any) => {
        return isValidCode === true || codeSupport === "" ? (
            <span
                onClick={() => {
                    setIsModalOpened(true);
                }}
                style={{
                    color: "hsl(0,0%,80%)",
                    width: "38px",
                }}
            >
                <ArrowDownIcon
                    fill="currentColor"
                    style={{ marginLeft: "8px" }}
                />
            </span>
        ) : (
            <components.DropdownIndicator {...props}>
                <ArrowDownIcon fill="currentColor" />
            </components.DropdownIndicator>
        );
    };

    return (
        <React.Fragment>
            <AvForm>
                {isShopHasAdyen ? (
                    <div className="d-flex align-items-center justify-content-between mt-3">
                        <StyledLabel htmlFor="example-input">
                            {t("Autofill")}
                        </StyledLabel>
                        <div className="pl-5">
                            <ReactSwitch
                                data-testid="monetics-adyen-autofill-switch"
                                uncheckedIcon={false}
                                checkedIcon={false}
                                handleDiameter={26}
                                offColor="#f7b4b8"
                                offHandleColor="#E30613"
                                checked={isAutoFill}
                                onChange={() => {
                                    if (
                                        !isAutoFill &&
                                        (port !== "" ||
                                            webhook !== "" ||
                                            ipAddress !== "" ||
                                            selectedIdAdyen.value !== "")
                                    ) {
                                        setIsEdited(true);
                                        setIsConfirmationModalOpened(true);
                                    } else {
                                        setIsEdited(true);
                                        setMerchantAccount(merchantAccountId);
                                        setAdyenConfig({
                                            ...adyenConfig,
                                            merchantAccount: merchantAccountId,
                                        });
                                        setIsAutoFill(!isAutoFill);
                                    }
                                }}
                                onColor="#c2eddd"
                                onHandleColor="#34C38F"
                                width={50}
                                height={20}
                            />
                        </div>
                    </div>
                ) : null}
                <div className="d-flex align-items-center justify-content-between mt-3">
                    <StyledLabel htmlFor="example-input">
                        {t("Adyen Configuration ")}
                    </StyledLabel>
                    <div className="pl-5">
                        <SettingsIcon
                            data-testid="monetics-adyen-config-icon"
                            className={classnames({
                                "not-allowed-icon__clz": isDisabled,
                                pointer__clz: !isDisabled,
                            })}
                            height={20}
                            width={20}
                            onClick={() => {
                                setIsConfig(true);
                                setIsModalOpened(true);
                                setCodeSupport("");
                            }}
                        />
                    </div>
                </div>
                <AvGroup>
                    <StyledLabel
                        htmlFor="example-input"
                        className="required__clz mt-3"
                    >
                        {t("ID Adyen")}
                    </StyledLabel>
                    {isShopHasAdyen === true && isAutoFill ? (
                        <StyledSelectInput
                            data-testid="monetics-adyen-id-select"
                            className={classnames("mnt_drp_mode", {
                                invalid__clz: inputMode || inputID,
                                readOnly__clz: isConsult,
                            })}
                            name="IDAdyen"
                            required
                            options={options}
                            placeholder={t("Select")}
                            onChange={async (e: any) => {
                                setSelectedIdAdyen(e);
                                setInputID(false);
                                setInputIp(false);
                                setInputWebhook(false);
                                setInputPortAdyen(false);
                                await getFetch(e.value);
                                setIsEdited(true);
                            }}
                            value={selectedIdAdyen}
                            maxMenuHeight="180px"
                            noOptionsMessage={() => t("No options")}
                        />
                    ) : (
                        <AvField
                            data-testid="monetics-adyen-id-input"
                            className={classnames("mnt_drp_mode", {
                                invalid__clz: inputMode || isIdExist || inputID,
                                readOnly__clz: isConsult,
                            })}
                            autocomplete="off"
                            id="idAdyen"
                            name="idAdyen"
                            placeholder={t("Write")}
                            type="text"
                            onChange={(e: any) => {
                                const rawIds =
                                    localStorage.getItem("adyenIds");
                                const ids: Record<string, string[]> = rawIds
                                    ? JSON.parse(rawIds) ?? {}
                                    : {};
                                setIsIdExist(
                                    editedData.Id !== undefined &&
                                        e.target.value === editedData.adyenIp
                                        ? false
                                        : (Object.keys(ids).includes(shopId)
                                              ? ids[shopId]
                                              : []
                                          ).includes(e.target.value)
                                );
                                setSelectedIdAdyen({
                                    value: e.target.value,
                                    label: e.target.value,
                                });
                                setInputID(false);
                                setIsEdited(true);
                            }}
                            value={selectedIdAdyen.value}
                        />
                    )}
                    {isIdExist ? (
                        <FieldError>
                            {t("The ID Adyen is already exists")}
                        </FieldError>
                    ) : null}
                    {inputID ? (
                        <FieldError>
                            {t("Please insert ID Adyen")}
                        </FieldError>
                    ) : null}
                </AvGroup>
                <AvGroup>
                    <StyledLabel
                        htmlFor="example-input"
                        className="mt-3 required__clz"
                    >
                        {t("IP address")}
                    </StyledLabel>
                    <AvField
                        data-testid="monetics-adyen-ip-input"
                        disabled={isAutoFill}
                        className={classnames("mnt_inp_ipAdress", {
                            input__clz: inputIp || ipExist,
                            readOnly__clz: isConsult,
                        })}
                        autocomplete="off"
                        id="ip-address"
                        name="ip-address"
                        placeholder={t("Write")}
                        type="text"
                        onChange={(e: any) => {
                            setIpAddress(e.target.value);
                            if (
                                !e.target.value.match(ipMatchWord) &&
                                e.target.value !== ""
                            ) {
                                setInputIp(true);
                            } else {
                                setInputIp(false);
                            }
                            setIsEdited(true);
                        }}
                        value={ipAddress}
                    />
                    {inputIp || ipExist ? (
                        <FieldError>
                            {t(
                                ipAddress === ""
                                    ? "Please enter a IP address"
                                    : !ipAddress.match(ipMatchWord)
                                    ? "IP address is invalid"
                                    : ipExist
                                    ? "The ip address is already exists"
                                    : ""
                            )}
                        </FieldError>
                    ) : null}
                </AvGroup>

                <AvGroup>
                    <StyledLabel
                        htmlFor="example-input"
                        className="required__clz mt-3"
                    >
                        {t("Port number")}
                    </StyledLabel>

                    <AvField
                        data-testid="monetics-adyen-port-input"
                        className={classnames("mnt_inp_ipAdyen", {
                            input__clz: inputPortAdyen,
                            readOnly__clz: isConsult,
                        })}
                        disabled={isAutoFill}
                        autocomplete="off"
                        name="port_num"
                        id="port_num"
                        placeholder={t("Write")}
                        type="text"
                        onChange={(e: any) => {
                            setPort(e.target.value);
                            setIsEdited(true);
                            if (
                                !e.target.value.match(numberMatchWord) &&
                                e.target.value !== ""
                            ) {
                                setInputPortAdyen(true);
                            } else {
                                setInputPortAdyen(false);
                            }
                        }}
                        value={port}
                    />
                    {inputPortAdyen ? (
                        <FieldError>
                            {t(
                                port === ""
                                    ? "Please enter a port number"
                                    : !port.match(numberMatchWord)
                                    ? "Port number is invalid"
                                    : ""
                            )}
                        </FieldError>
                    ) : null}
                </AvGroup>
                <AvGroup>
                    <StyledLabel
                        htmlFor="example-input"
                        className="required__clz mt-3"
                    >
                        {t("Webhook Port")}
                    </StyledLabel>
                    <AvField
                        data-testid="monetics-adyen-webhook-input"
                        className={classnames("mnt_inp_webhook", {
                            input__clz: inputWebHook,
                            readOnly__clz: isConsult,
                        })}
                        disabled={isAutoFill}
                        autocomplete="off"
                        id="webhook"
                        name="webhook"
                        placeholder={t("Write")}
                        type="text"
                        onChange={(e: any) => {
                            setWebhook(e.target.value);
                            setIsEdited(true);
                            if (
                                !e.target.value.match(numberMatchWord) &&
                                e.target.value !== ""
                            ) {
                                setInputWebhook(true);
                            } else {
                                setInputWebhook(false);
                            }
                        }}
                        value={webhook}
                    />
                    {inputWebHook && (
                        <FieldError>
                            {t(
                                port === ""
                                    ? "Please enter a webhook"
                                    : !webhook.match(numberMatchWord)
                                    ? "Webhook is invalid"
                                    : ""
                            )}
                        </FieldError>
                    )}
                </AvGroup>
                <AvGroup>
                    <StyledLabel
                        htmlFor="payment type"
                        className="required__clz mt-3"
                    >
                        {t("Mode")}
                    </StyledLabel>
                    <StyledSelectInput
                        data-testid="monetics-adyen-mode-select"
                        disabled
                        components={{ DropdownIndicator }}
                        className={classnames("mnt_drp_mode", {
                            invalid__clz: inputMode,
                            readOnly__clz: isConsult,
                        })}
                        name="mode"
                        required
                        options={
                            codeSupport === ""
                                ? []
                                : [
                                      {
                                          label: MONETIC_MODE_TEST,
                                          value: MONETIC_MODE_TEST,
                                      },
                                      {
                                          label: MONETIC_MODE_PRODUCTION,
                                          value: MONETIC_MODE_PRODUCTION,
                                      },
                                  ]
                        }
                        placeholder={t("Select")}
                        onChange={(e: any) => {
                            setMode(e.label);
                            setInputMode(false);
                            setIsEdited(true);
                        }}
                        value={{ label: mode, value: mode }}
                        onFocus={() => {
                            if (codeSupport === "") {
                                setIsConfig(false);
                                setIsModalOpened(true);
                            }
                        }}
                    />
                    {inputMode && (
                        <FieldError>
                            {t("Please select a mode")}
                        </FieldError>
                    )}
                </AvGroup>
            </AvForm>
            {isModalOpened ? (
                <SupportCodeModal
                    isModalOpened={isModalOpened}
                    setIsModalOpened={setIsModalOpened}
                    codeSupport={codeSupport}
                    setCodeSupport={setCodeSupport}
                    isValidCode={isValidCode}
                    setIsValidCode={setIsValidCode}
                    isConfig={isConfig}
                    setIsModalConfigOpened={setIsConfigurationModalOpened}
                />
            ) : null}
            {isConfigurationModalOpened ? (
                <AdyenConfigurationModal
                    isModalOpened={isConfigurationModalOpened}
                    setIsModalOpened={setIsConfigurationModalOpened}
                    setCodeSupport={setCodeSupport}
                    merchantAccount={
                        isAutoFill
                            ? merchantAccountId
                            : adyenConfig.merchantAccount ?? ""
                    }
                    setMerchantAccount={setMerchantAccount}
                    cryptoVersion={adyenConfig.cryptoVersion ?? ""}
                    setCryptoVersion={setCryptoVersion}
                    keyIdentifier={adyenConfig.keyIdentifier ?? ""}
                    setKeyIdentifier={setKeyIdentifier}
                    passphrase={adyenConfig.passphrase ?? ""}
                    setPassphrase={setPassphrase}
                    keyVersion={adyenConfig.keyVersion ?? ""}
                    setKeyVersion={setKeyVersion}
                    communication={adyenConfig.communication ?? COMMUNICATION_LOCAL}
                    setCommunication={setCommunication}
                    currency={currencyByShop}
                    setAdyenConfig={setAdyenConfig}
                    adyenConfig={adyenConfig}
                    webhook={adyenConfig.webhook ?? ""}
                    setWebhook={setWebhookConfig}
                    merchantTicket={adyenConfig.merchantTicket ?? ""}
                    customerTicket={adyenConfig.customerTicket ?? true}
                    apiKey={adyenConfig.apiKey ?? ""}
                    userName={adyenConfig.userName ?? ""}
                    userPassword={adyenConfig.userPassword ?? ""}
                    setMerchantTicket={setMerchantTicket}
                    setCustomerTicket={setCustomerTicket}
                    setApiKey={setApiKey}
                    setUserName={setUserName}
                    setUserPassword={setUserPassword}
                    isConsult={isConsult}
                    devise={devise}
                    shopIds={shopIds}
                    setIsEdited={setIsEdited}
                    setShopIdentifier={setShopIdentifier}
                    shopIdentifier={adyenConfig.shopIdentifier ?? ""}
                    editedData={editedData}
                    isAutoFill={isAutoFill}
                />
            ) : null}
            {isConfirmationModalOpened ? (
                <ConfirmationModal
                    setIsAutoFill={setIsAutoFill}
                    isModalOpened={isConfirmationModalOpened}
                    setIsModalOpened={setIsConfirmationModalOpened}
                    setIsEdited={setIsEdited}
                    getFetch={() => getFetch(selectedIdAdyen.value)}
                />
            ) : null}
        </React.Fragment>
    );
}

function addToBase(ip: string, port: number) {
    let parts = ip.split(".");
    let lastNumber = parseInt(parts[3], 10);
    return port + lastNumber;
}
